import React from "react";
import HighlightedText from "../../../../components/HighlightKeyword";

export default function TambActNoActNamePublicationTable({
  documentList,
  openModal,
  query,
  language,
  getArrowIcon,
  handleSortDocument,
}) {
  const getRoyalAssentDate = (egCustomAttributeValue) => {
    
    const targetValue = egCustomAttributeValue?.find(
      (item) =>
        item?.attributeID?.attributeID === 247 ||
        item?.attributeID?.attributeID === 249
    )?.value;

    return targetValue;
  };

  return (
    <table className="case-law-table">
      <thead>
        <tr>
          <th
            style={{ width: "10%" }}
            onClick={() => handleSortDocument("tamb")}
          >
            <div className="case-law-table-header">
              Addition {getArrowIcon("tamb")}
            </div>
          </th>
          <th
            style={{ width: "10%" }}
            onClick={() => handleSortDocument("actNo")}
          >
            <div className="case-law-table-header">
              Act No {getArrowIcon("actNo")}
            </div>
          </th>
          <th
            style={{ minWidth: "20vw" }}
            onClick={() => handleSortDocument("actTitleBI")}
          >
            <div className="case-law-table-header">
              Act Name {getArrowIcon("actTitleBI")}
            </div>
          </th>
          <th
            style={{ width: "20%" }}
            onClick={() => handleSortDocument("publicationDate")}
          >
            <div className="case-law-table-header">
              Publication {getArrowIcon("publicationDate")}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {documentList.map((item, index) => (
          <tr key={index}>
            <td>{item?.egDocumentDto?.tamb}</td>
            <td>
              <p>{item?.egDocumentDto?.actNo}</p>
            </td>
            <td>
              <div className="egTitle-title">
                <HighlightedText
                  paragraph={
                    language === "EN"
                      ? item?.egDocumentDto?.actTitleBI
                      : item?.egDocumentDto?.actTitleBM
                  }
                  keyword={query}
                  onClick={() => {
                    openModal(item?.documentBlobDto?.fileUUID, 1);
                  }}
                />
              </div>
              <div style={{ display: "flex", gap: "5px" }}>
                <p>
                  <strong> Royal Assent Date: </strong>
                </p>
                <p>
                  {getRoyalAssentDate(
                    item?.egDocumentDto?.egCustomAttributeValue
                  )}
                </p>
              </div>
              <div style={{ display: "flex", gap: "5px" }}>
                <p>C.I.F:</p>
                <p style={{ color: "red" }}>{item?.egDocumentDto?.cif}</p>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {new Date(
                item?.egDocumentDto?.publicationDate
              ).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
